<template>
  <div>
    <div class="form-content">
      <div v-if="!isBindingEditMode" class="quick-create-btn">
        <el-popover placement="right" width="200" trigger="click">
          <el-select
            v-model="job_id"
            filterable
            clearable
            placeholder="请选择关联岗位"
            @change="selectJob"
          >
            <el-option
              v-for="item in jobList"
              :key="item.id"
              :label="item.recruit_post"
              :value="item.id"
            >
            </el-option>
          </el-select>
          <el-button slot="reference" type="primary" size="mini">
            快速创建
          </el-button>
        </el-popover>
      </div>

      <el-form
        ref="refForm"
        :inline="true"
        label-width="100px"
        :model="companyFormData"
      >
        <el-col
          v-for="(item, index) in formList"
          :key="index"
          :xs="24"
          :sm="24"
          :md="12"
          :lg="12"
          :xl="12"
          :span="12"
        >
          <el-form-item
            :label="item.label"
            :prop="item.props"
            :required="item.required"
            :show-message="false"
            :rules="[
              {
                required: item.required,
                message: '请输入' + item.label,
                trigger: 'blur',
              },
            ]"
          >
            <template v-if="item.type == 'input'">
              <el-input
                v-if="isReadonlyField(item)"
                :value="getReadonlyValue(item)"
                disabled
              ></el-input>
              <el-input
                v-else
                v-model="companyFormData[item.props]"
                :placeholder="item.placeholder"
                :disabled="isFieldDisabled(item)"
              ></el-input>
            </template>
            <template v-else-if="item.type == 'textarea'">
              <el-input
                v-if="isReadonlyField(item)"
                :value="getReadonlyValue(item)"
                type="textarea"
                disabled
              ></el-input>
              <el-input
                v-else
                v-model="companyFormData[item.props]"
                type="textarea"
                :disabled="isFieldDisabled(item)"
              ></el-input>
            </template>
            <template v-else-if="item.type == 'picker'">
              <el-input
                v-if="isReadonlyField(item)"
                :value="getReadonlyValue(item)"
                disabled
              ></el-input>
              <div
                v-else
                :class="[
                  'picker-field-wrap',
                  {
                    'picker-field-wrap--with-tip': item.props === 'mission_type',
                  },
                ]"
              >
                <el-select
                  v-model="companyFormData[item.props]"
                  :placeholder="item.placeholder || '请选择'"
                  clearable
                  filterable
                  :disabled="isFieldDisabled(item)"
                >
                  <el-option
                    v-for="(item1, index1) in item.selectOption"
                    :key="index1"
                    :label="item1.label"
                    :value="item1.value"
                  ></el-option>
                </el-select>
                <el-tooltip
                  v-if="item.props === 'mission_type'"
                  class="item"
                  effect="dark"
                  placement="right"
                >
                  <div slot="content">
                    <div>设置公开，所有用户均可领取该任务</div>
                    <div>设置非公开，仅由您分享二维码的用户可领取该任务</div>
                  </div>
                  <i class="el-icon-warning"></i>
                </el-tooltip>
              </div>
            </template>
            <template v-else-if="item.type == 'multiplePicker'">
              <div
                :class="[
                  'multiple-picker-wrap',
                  {
                    'multiple-picker-wrap--with-action':
                      item.props === 'task_ids' && effectiveShowCreateRecruitAction,
                  },
                ]"
              >
                <el-select
                  v-model="companyFormData[item.props]"
                  :placeholder="item.placeholder || '请选择'"
                  clearable
                  filterable
                  multiple
                  :disabled="isFieldDisabled(item)"
                >
                  <el-option
                    v-for="(item1, index1) in item.selectOption"
                    :key="index1"
                    :label="item1.label"
                    :value="item1.value"
                  ></el-option>
                </el-select>
                <el-button
                  v-if="item.props === 'task_ids' && effectiveShowCreateRecruitAction"
                  class="recruit-create-btn"
                  type="primary"
                  size="medium"
                  @click="openCreateRecruitDialog"
                >
                  新建岗位
                </el-button>
              </div>
            </template>
            <template v-else-if="item.type == 'cascader'">
              <el-input
                v-if="isReadonlyField(item)"
                :value="getReadonlyValue(item)"
                disabled
              ></el-input>
              <el-cascader
                v-else
                v-model="companyFormData[item.props]"
                :placeholder="item.placeholder || '请选择'"
                clearable
                filterable
                :options="item.selectOption"
                :disabled="isFieldDisabled(item)"
              >
              </el-cascader>
            </template>
            <template v-else-if="item.type == 'mapPicker'">
              <el-input
                v-if="isReadonlyField(item)"
                :value="getReadonlyValue(item)"
                disabled
              ></el-input>
              <TencentMapPicker
                v-else
                v-model="companyFormData[item.props]"
                :placeholder="item.placeholder"
                @confirmMap="handleConfirmMap"
              />
            </template>
            <template v-else-if="item.type == 'salary'">
              <div style="width: 260px">
                <el-col :span="10">
                  <el-input
                    v-model="companyFormData.min_salary"
                    class="salary-input"
                    placeholder="最低薪资"
                    :disabled="isFieldDisabled(item)"
                  />
                </el-col>
                <el-col :span="2" class="text-center">
                  <span class="text-gray-500">-</span>
                </el-col>
                <el-col :span="10">
                  <el-input
                    v-model="companyFormData.max_salary"
                    class="salary-input"
                    placeholder="最高薪资"
                    :disabled="isFieldDisabled(item)"
                  />
                </el-col>
                <el-col :span="2">
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="如若填写相同薪资，则展示固定薪资"
                    placement="right"
                  >
                    <i class="el-icon-warning"></i>
                  </el-tooltip>
                </el-col>
              </div>
            </template>
          </el-form-item>
        </el-col>

        <el-form-item
          required
          label-width="120px"
          label="请选择任务类型"
          prop="name"
          id="desc"
          :show-message="false"
        >
          <el-checkbox-group
            v-model="companyFormData.name"
            size="small"
            :max="10"
            @change="handleTaskChange"
            :disabled="isBindingEditMode"
          >
            <el-checkbox
              v-for="item in categoryList"
              class="task-type-checkbox"
              :key="item.id"
              :label="item.name"
              border
            >
            </el-checkbox>
          </el-checkbox-group>
        </el-form-item>

        <div class="description-box">
          <div class="task-description-label">任务描述</div>
          <el-input
            v-model="companyFormData.missionContent"
            type="textarea"
            rows="6"
            placeholder="请输入任务描述"
            maxlength="500"
            show-word-limit
            :disabled="isBindingEditMode"
          >
          </el-input>
        </div>

        <el-col
          v-for="(item, index) in formList2"
          :key="`ext-${index}`"
          :xs="24"
          :sm="24"
          :md="12"
          :lg="12"
          :xl="12"
          :span="12"
        >
          <el-form-item
            label-width="80px"
            :label="item.label"
            :prop="item.props"
            :required="item.required"
            :show-message="false"
            :rules="[
              {
                required: item.required,
                message: '请输入' + item.label,
                trigger: 'blur',
              },
            ]"
          >
            <template v-if="item.type == 'picker'">
              <el-input
                v-if="isReadonlyField(item)"
                :value="getReadonlyValue(item)"
                disabled
              ></el-input>
              <div
                v-else
                :class="[
                  'picker-field-wrap',
                  {
                    'picker-field-wrap--with-tip': item.props === 'mission_type',
                  },
                ]"
              >
                <el-select
                  v-model="companyFormData[item.props]"
                  :placeholder="item.placeholder || '请选择'"
                  clearable
                  filterable
                  :disabled="isFieldDisabled(item)"
                >
                  <el-option
                    v-for="(item1, index1) in item.selectOption"
                    :key="index1"
                    :label="item1.label"
                    :value="item1.value"
                  ></el-option>
                </el-select>
                <el-tooltip
                  v-if="item.props === 'mission_type'"
                  class="item"
                  effect="dark"
                  placement="right"
                >
                  <div slot="content">
                    <div>设置公开，所有用户均可领取该任务</div>
                    <div>设置非公开，仅由您分享二维码的用户可领取该任务</div>
                  </div>
                  <i class="el-icon-warning"></i>
                </el-tooltip>
              </div>
            </template>
          </el-form-item>
        </el-col>
      </el-form>

      <div class="btn">
        <el-button
          type="primary"
          size="medium"
          :loading="qrLoading"
          :disabled="qrLoading"
          @click="handlePrimaryAction"
        >
          {{ isBindingEditMode ? "保存" : "生成合作邀请码" }}
        </el-button>
      </div>
    </div>

    <el-dialog
      width="40%"
      title="系统提示"
      :close-on-click-modal="false"
      :visible.sync="qrDialogVisible"
      append-to-body
      @close="handleQRClose"
    >
      <div class="dialog-title">
        <i class="el-icon-success"></i>
        <span class="title-text">手机扫一扫，请到手机端分享</span>
      </div>
      <div class="center-box">
        <div class="code" v-if="OrImage">
          <img :src="OrImage" class="QR-code" />
          <div class="tips">打开微信[扫一扫]</div>
        </div>
        <div v-if="showAlipayQr && alipayOrImage" class="alipay-code code">
          <img :src="alipayOrImage" class="QR-code" />
          <div class="tips">打开支付宝[扫一扫]</div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" size="medium" @click="handleQRClose">
          关闭
        </el-button>
      </div>
    </el-dialog>
    <el-dialog
      width="40%"
      title="系统提示"
      :close-on-click-modal="false"
      :visible.sync="reviewDialogVisible"
      append-to-body
      @close="handleReviewClosed"
    >
      <div class="review-notice">
        <i class="el-icon-warning-outline review-notice__icon"></i>
        <div class="review-notice__content">
          任务提交后将进入平台审核，审核通过后方可生成二维码。请等待审核结果，审核通过后可在任务列表查看并分享二维码。
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          size="medium"
          @click="reviewDialogVisible = false"
        >
          关闭
        </el-button>
      </div>
    </el-dialog>
    <el-dialog
      v-if="showCreateRecruitAction"
      title="新建岗位"
      :visible.sync="createRecruitDialogVisible"
      width="70%"
      append-to-body
      destroy-on-close
    >
      <CreateEditContent
        :show-create-task-action="false"
        @confirm="handleRecruitCreated"
      />
    </el-dialog>
  </div>
</template>

<script>
import json from "../../../../public/citys.json";
import {
  gettreeList,
  SALARY_TYPE_LIST,
  TOG_SALARY_TYPE_VALUE_MAP,
} from "@/utils/utils";
import TencentMapPicker from "@/components/TencentMapPicker.vue";

const BINDING_EDIT_STORAGE_KEY = "privateTaskBindingEditData";
const ONLINE_OPTIONAL_FIELDS = ["work_city", "address", "min_qualification"];
const ONLINE_SALARY_TYPE_LIST = [
  ...SALARY_TYPE_LIST,
  { label: "分钟结", value: 7 },
  { label: "单集结", value: 8 },
];

const getDefaultFormData = () => ({
  category_id: [],
  name: [],
  missionContent: "",
  task_ids: [],
  work_mode: "",
  mission_type: 1,
  renew_type: 1,
});

export default {
  name: "CreateTaskContent",
  components: {
    CreateEditContent: () => import("@/pages/recruit/components/CreateEditContent.vue"),
    TencentMapPicker,
  },
  props: {
    silentQrDialog: {
      type: Boolean,
      default: false,
    },
    showCreateRecruitAction: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      job_id: "",
      jobList: [],
      taskList: [],
      bindingEditSource: {},
      categoryList: [],
      host: window.location.host,
      noaliqrcodeUrl: ["khlztrz.51xinlong.com", "www.ztrztd.com"],
      qrDialogVisible: false,
      reviewDialogVisible: false,
      qrLoading: false,
      createRecruitDialogVisible: false,
      OrImage: "",
      alipayOrImage: "",
      companyFormData: getDefaultFormData(),
      formList: [
        {
          required: true,
          label: "任务名称",
          type: "input",
          props: "title",
          value: "",
          placeholder: "请输入任务名称",
          disabled: false,
          show: true,
        },
        {
          required: true,
          label: "工作方式",
          type: "picker",
          props: "work_mode",
          selectOption: [
            { label: "线下", value: 1 },
            { label: "线上", value: 2 },
          ],
          placeholder: "请选择工作方式",
          disabled: false,
          show: true,
        },
        {
          required: true,
          label: "行业类型",
          type: "cascader",
          props: "recruit_type_id",
          value: [],
          selectOption: [],
          placeholder: "请选择行业类型",
          disabled: false,
          show: true,
        },
        {
          required: true,
          label: "工作地点",
          type: "cascader",
          props: "work_city",
          value: "",
          selectOption: json.data,
          valueLevel: "more",
          placeholder: "请选择工作地点",
          disabled: false,
          show: true,
        },
        
        {
          required: true,
          label: "结算方式",
          type: "picker",
          props: "salary_type",
          selectOption: SALARY_TYPE_LIST,
          placeholder: "请选择结算方式",
          value: "",
          disabled: false,
          show: true,
        },
        {
          required: true,
          label: "详细地点",
          type: "mapPicker",
          props: "address",
          placeholder: "请点击地图选点",
          value: "",
          disabled: false,
          show: true,
        },
        {
          required: true,
          label: "用工人数",
          type: "input",
          props: "person_num",
          value: "",
          placeholder: "请输入用工人数",
          disabled: false,
          show: true,
        },
        {
          required: true,
          label: "学历要求",
          type: "picker",
          props: "min_qualification",
          selectOption: [
            { label: "不限", value: "0" },
            { label: "小学", value: "1" },
            { label: "初中", value: "2" },
            { label: "高中", value: "3" },
            { label: "大专", value: "4" },
            { label: "本科及以上", value: "5" },
          ],
          placeholder: "请选择学历要求",
          value: "",
          disabled: false,
          show: true,
        },
        {
          required: true,
          label: "薪资范围",
          type: "salary",
          props: "min_salary",
          placeholder: "请输入薪资",
          value: "",
          show: true,
        },
        
        {
          required: false,
          label: "绑定岗位",
          type: "multiplePicker",
          props: "task_ids",
          value: [],
          selectOption: [],
          placeholder: "请选择绑定岗位",
          disabled: false,
          show: true,
        },
      ],
      formList2: [
        {
          required: true,
          label: "任务属性",
          type: "picker",
          props: "mission_type",
          selectOption: [
            { label: "非公开", value: 1 },
            { label: "公开", value: 2 },
          ],
          placeholder: "请选择任务属性",
          value: "",
          disabled: false,
          show: true,
        },
        {
          required: false,
          label: "任务时效",
          type: "picker",
          props: "renew_type",
          selectOption: [
            { label: "1个月", value: 1 },
            { label: "2个月", value: 2 },
            { label: "3个月", value: 3 },
            { label: "长期", value: 99 },
          ],
          placeholder: "请选择任务时效",
          value: 1,
          disabled: false,
          show: true,
        },
      ],
    };
  },
  computed: {
    showAlipayQr() {
      return !this.noaliqrcodeUrl.includes(this.host);
    },
    isBindingEditMode() {
      return this.$route.query.mode === "bindingEdit";
    },
    effectiveShowCreateRecruitAction() {
      return this.showCreateRecruitAction;
    },
  },
  watch: {
    "companyFormData.min_salary"(val) {
      if (val && !this.companyFormData.salary_type) {
        this.$message.error("请先选择结算方式");
        this.companyFormData.min_salary = "";
      }
    },
    "companyFormData.max_salary"(val) {
      if (val && !this.companyFormData.salary_type) {
        this.$message.error("请先选择结算方式");
        this.companyFormData.max_salary = "";
      }
    },
    "companyFormData.work_mode"(val, oldVal) {
      if (val === oldVal) {
        return;
      }
      if (!this.isBindingEditMode) {
        this.companyFormData.recruit_type_id = [];
      }
      if (val != 2 && [7, 8].includes(Number(this.companyFormData.salary_type))) {
        this.companyFormData.salary_type = "";
      }
      this.updateWorkModeConfig();
      this.getDailyTaskIndustryList();
    },
  },
  methods: {
    updateWorkModeConfig() {
      const isOnline = this.companyFormData.work_mode == 2;
      this.formList.forEach((item) => {
        if (ONLINE_OPTIONAL_FIELDS.includes(item.props)) {
          item.required = !isOnline;
        }
        if (item.props === "salary_type") {
          item.selectOption = isOnline ? ONLINE_SALARY_TYPE_LIST : SALARY_TYPE_LIST;
        }
      });
      if (isOnline) {
        this.$nextTick(() => {
          this.$refs.refForm && this.$refs.refForm.clearValidate(ONLINE_OPTIONAL_FIELDS);
        });
      }
    },
    openCreateRecruitDialog() {
      if (!this.showCreateRecruitAction) return;
      this.createRecruitDialogVisible = true;
    },
    normalizeTaskIds(taskIds) {
      if (Array.isArray(taskIds)) {
        return taskIds
          .map((item) =>
            item === null || item === undefined ? "" : String(item),
          )
          .filter(Boolean);
      }
      if (typeof taskIds === "string") {
        return taskIds
          .split(/[,，、]/)
          .map((item) => item.trim())
          .filter(Boolean);
      }
      if (taskIds || taskIds === 0) {
        return [String(taskIds)];
      }
      return [];
    },
    normalizeArrayValue(value) {
      if (Array.isArray(value)) {
        return value;
      }
      if (typeof value === "string") {
        return value
          .split(/[,，、]/)
          .map((item) => item.trim())
          .filter(Boolean);
      }
      if (value || value === 0) {
        return [value];
      }
      return [];
    },
    isFieldDisabled(item) {
      return !!item.disabled || (this.isBindingEditMode && item.props !== "task_ids");
    },
    isReadonlyField(item) {
      return this.isBindingEditMode && item.props !== "task_ids";
    },
    getSelectLabel(options = [], value) {
      const current = options.find(
        (item) => String(item.value) === String(value),
      );
      return current ? current.label : "";
    },
    getReadonlyValue(item) {
      const row = this.bindingEditSource || {};
      switch (item.props) {
        case "recruit_type_id":
          return (
            row.recruit_type_name ||
            this.normalizeArrayValue(this.companyFormData[item.props]).join("/") ||
            "-"
          );
        case "work_city":
          return this.companyFormData.all_address || row.all_address || '-';
        case "salary_type":
          return (
            row.salary_type_name ||
            this.getSelectLabel(item.selectOption, this.companyFormData[item.props]) ||
            "-"
          );
        case "address":
          return this.companyFormData.address || row.address || "-";
        case "min_qualification":
        case "work_mode":
        case "mission_type":
        case "renew_type":
          return (
            this.getSelectLabel(item.selectOption, this.companyFormData[item.props]) ||
            row[`${item.props}_text`] ||
            "-"
          );
        default:
          return this.companyFormData[item.props] || row[item.props] || "-";
      }
    },
    initBindingEditData() {
      const raw = window.sessionStorage.getItem(BINDING_EDIT_STORAGE_KEY);
      if (!raw) return;
      try {
        const row = JSON.parse(raw) || {};
        console.log(row,999999)

        this.bindingEditSource = row;
        this.companyFormData = {
          ...getDefaultFormData(),
          id: row.id || "",
          title: row.title || "",
          recruit_type_id: this.normalizeArrayValue(row.recruit_type_id),
          work_city: [row.province, row.city, row.area],
          salary_type: row.salary_type || "",
          address: row.address || "",
          lat: row.lat,
          lon: row.lon,
          person_num: row.person_num || row.worked_num || "",
          min_qualification:
            row.min_qualification !== undefined && row.min_qualification !== null
              ? String(row.min_qualification)
              : row.minimum_education !== undefined && row.minimum_education !== null
              ? String(row.minimum_education)
              : "",
          min_salary: row.min_salary || "",
          max_salary: row.max_salary || "",
          task_ids: this.normalizeTaskIds(row.task_ids),
          work_mode: row.work_mode || "",
          mission_type: row.mission_type || 1,
          renew_type: row.renew_type || 1,
          missionContent: row.mission_content || row.missionContent || "",
          name: row.category_name.split("、") || [], 
          category_id: row.category_id.split("、") || [],
        };
        this.updateWorkModeConfig();
      } catch (error) {
        console.log(error);
      }
    },
    getRecruitId(payload) {
      if (!payload) return "";
      if (typeof payload === "string" || typeof payload === "number") {
        return payload;
      }
      if (payload.id) {
        return payload.id;
      }
      if (payload.data && payload.data.id) {
        return payload.data.id;
      }
      return "";
    },
    async handleRecruitCreated(payload) {
      await this.getQuickRecruitPostList();
      const recruitId = this.getRecruitId(payload);
      const recruitIdValue =
        recruitId === null || recruitId === undefined ? "" : String(recruitId);
      const taskIds = Array.isArray(this.companyFormData.task_ids)
        ? [...this.companyFormData.task_ids]
        : [];
      if (recruitIdValue && !taskIds.includes(recruitIdValue)) {
        taskIds.push(recruitIdValue);
      }
      this.companyFormData.task_ids = taskIds;
      this.createRecruitDialogVisible = false;
      this.$message.success("岗位创建成功");
    },
    resetFormData() {
      this.job_id = "";
      this.companyFormData = getDefaultFormData();
      this.$nextTick(() => {
        this.$refs.refForm && this.$refs.refForm.clearValidate();
      });
    },
    handleQRClose() {
      this.qrDialogVisible = false;
      this.OrImage = "";
      this.alipayOrImage = "";
      this.$router.go(-1);
    },
    handleReviewClosed() {
      this.$router.go(-1);
    },
    async loadCategoryList() {
      this.categoryList = await this.$api.getCustomerCategoryList();
    },
    async getQuickRecruitPostList() {
      const res = await this.$api.recruitTaskList({
        page_size: 0,
        current_page: 0,
      });
      this.jobList = res.data || [];
      this.taskList = res.data || [];
      const options = this.taskList.map((item) => ({
        label: item.recruit_post || item.title || String(item.id),
        value: String(item.id),
      }));
      this.formList.forEach((item) => {
        if (item.props === "task_ids") {
          item.selectOption = options;
        }
      });
    },
    async getDailyTaskIndustryList() {
      const params = {};
      if (this.companyFormData.work_mode == 2) {
        params.type = 2;
      }
      const res = await this.$api.getDailyTaskIndustryList(params);
      const industryItem = this.formList.find((item) => item.props === "recruit_type_id");
      if (!industryItem) {
        return;
      }
      industryItem.selectOption = gettreeList(
        res,
        "industry_type_name",
        "id",
      );
    },
    selectJob(e) {
      const currentJob = this.jobList.find((item) => e == item.id);
      if (!currentJob) return;
      this.companyFormData = {
        ...this.companyFormData,
        title: currentJob.recruit_post,
        salary_type: TOG_SALARY_TYPE_VALUE_MAP[currentJob.salary_type],
        work_city: [currentJob.province, currentJob.city, currentJob.area],
        min_qualification: "" + currentJob.minimum_education,
        min_salary: currentJob.min_salary,
        max_salary: currentJob.max_salary,
        person_num: currentJob.worked_num,
        address: currentJob.address,
        lat: currentJob.lat,
        lon: currentJob.lon,
        renew_type: currentJob.renew_type || 1,
      };
    },
    handleConfirmMap(payload) {
      this.companyFormData.address = payload.address;
      this.companyFormData.lat = payload.lat;
      this.companyFormData.lon = payload.lon;
    },
    handleTaskChange(val) {
      if (this.isBindingEditMode) {
        return;
      }
      const selected = this.categoryList.filter((item) =>
        val.includes(item.name),
      );
      this.companyFormData.name = selected.map((item) => item.name);
      this.companyFormData.category_id = selected.map((item) => item.id);
    },
    async validateForm() {
      const formValid = await new Promise((resolve) => {
        this.$refs.refForm.validate((valid) => resolve(valid));
      });
      if (!formValid) {
        this.$message.error("数据验证失败，请检查必填项数据！");
        return false;
      }
      if (!this.validateSalaryRange()) {
        return false;
      }
      if (!this.companyFormData.name.length) {
        this.$message.error("请选择任务类型");
        return false;
      }
      if (!this.companyFormData.missionContent) {
        this.$message.error("请输入任务描述");
        return false;
      }
      if (!this.companyFormData.category_id.length) {
        this.$message.error("请选择任务类型");
        return false;
      }
      if (
        !Array.isArray(this.companyFormData.recruit_type_id) ||
        !this.companyFormData.recruit_type_id.length
      ) {
        this.$message.error("请选择行业类型");
        return false;
      }
      if (
        this.companyFormData.work_mode != 2 &&
        (!Array.isArray(this.companyFormData.work_city) ||
          !this.companyFormData.work_city.length)
      ) {
        this.$message.error("请选择工作地点");
        return false;
      }
      return true;
    },
    validateSalaryRange() {
      const { min_salary, max_salary, salary_type } =
        this.companyFormData || {};
      if (!salary_type) {
        this.$message.error("请先选择结算方式");
        return false;
      }
      if (!max_salary) {
        this.$message.error("请输入最高薪资金额");
        return false;
      }
      if (!min_salary) {
        this.$message.error("请输入最低薪资金额");
        return false;
      }
      const minVal = Number(min_salary);
      const maxVal = Number(max_salary);
      if (Number.isNaN(minVal) || Number.isNaN(maxVal)) {
        this.$message.error("薪资范围需为数字");
        return false;
      }
      if (minVal > maxVal) {
        this.$message.error("最低薪资不能高于最高薪资");
        return false;
      }
      const salaryLimits = {
        1: { min: 80, max: 5000 },
        2: { min: 500, max: 20000 },
        3: { min: 2000, max: 100000 },
        4: { min: 100, max: 20000 },
        // 5: { min: 1000, max: 500000 },
        6: { min: 10, max: 500 },
        7: { min: 100, max: 20000 },
        8: { min: 100, max: 20000 },
      };
      const limit = salaryLimits[salary_type];
      if (limit) {
        if (minVal < limit.min) {
          this.$message.error(`最低薪资为${limit.min}元`);
          return false;
        }
        if (maxVal > limit.max) {
          this.$message.error(`超出薪资上限${limit.max}元`);
          return false;
        }
      }
      return true;
    },
    async createQrCode(id) {
      let pathPrefix = "/pages/projectsign/projectsign";
      if (this.$config.domain.miniappPath) {
        pathPrefix = this.$config.domain.miniappPath;
      }
      const args = {
        path: `${pathPrefix}?id=${id}&companyId=${this.mxCompanyId}&settlementId=${this.mxSettlementId}&scene_id=1047`,
        appId: this.mxDomain.appId,
        id,
      };
      const res = await this.$api.createQrcode(args);
      if (res) {
        this.OrImage = res;
      }
    },
    async createAlipayQrCode(id) {
      let pathPrefix = "pages/projectsign/projectsign";
      if (this.$config.domain.miniappPath) {
        pathPrefix = this.$config.domain.miniappPath;
      }
      const args = {
        path: `${pathPrefix}?id=${id}&companyId=${this.mxCompanyId}&settlementId=${this.mxSettlementId}&scene_id=1047`,
        query_param: `id=${id}&companyId=${this.mxCompanyId}&settlementId=${this.mxSettlementId}&scene_id=1047`,
        describe: "扫描此二维码",
        appId: this.mxDomain.alipayAppId,
        id,
      };
      const res = await this.$api.createQrcode(args);
      if (res && JSON.stringify(res) !== "{}") {
        this.alipayOrImage = res ?? "";
      }
    },
    async getQRCode() {
      const nameList = [];
      this.companyFormData.name.forEach((item) => {
        nameList.push(item.substring(0, item.length - 2));
      });
      const names = nameList.join("、");
      const name = `${names}`;
      const remark = `因委托方业务发展，现需要若干有相关服务经验或能力的自由职业者提供${this.companyFormData.name.join(
        "、",
      )}，具体要求和费用由委托方公布。`;
      const workCityArr = Array.isArray(this.companyFormData.work_city)
        ? this.companyFormData.work_city
        : [];
      const args = {
        name,
        remark,
        category_id: this.companyFormData.category_id.join("、"),
        category_name: this.companyFormData.name.join("、"),
        mission_content: this.companyFormData.missionContent ?? "",
        task_ids: this.companyFormData.task_ids || [],
        lat: this.companyFormData.lat,
        lon: this.companyFormData.lon,
        province: workCityArr[0] || "",
        city: workCityArr[1] || "",
        area: workCityArr[2] || "",
        salary_type: this.companyFormData.salary_type,
        min_salary: this.companyFormData.min_salary,
        max_salary: this.companyFormData.max_salary,
        min_qualification: this.companyFormData.min_qualification,
        address: this.companyFormData.address,
        recruit_type_id: this.companyFormData.recruit_type_id[
          this.companyFormData.recruit_type_id.length - 1
        ],
        title: this.companyFormData.title,
        person_num: this.companyFormData.person_num,
        work_mode: this.companyFormData.work_mode,
        mission_type: this.companyFormData.mission_type,
        renew_type: this.companyFormData.renew_type || 1,
      };
      const res = await this.$api.getQRCode(args);
      if (!res) return;
      this.OrImage = "";
      this.alipayOrImage = "";
      await this.createQrCode(res);
      if (
        this.showAlipayQr &&
        (this.mxDomain.appId == "1004" || this.mxDomain.appId == "1001")
      ) {
        await this.createAlipayQrCode(res);
      }
      await this.getQuickRecruitPostList();
      if (!this.silentQrDialog) {
        this.reviewDialogVisible = true;
      }
      this.$emit("confirm", res);
    },
    async saveTaskBinding() {
      if (!this.companyFormData.id) {
        this.$message.error("未获取到任务id");
        return;
      }
      this.qrLoading = true;
      try {
        await this.$api.updateMissionTaskBinding({
          id: this.companyFormData.id,
          task_ids: this.normalizeTaskIds(this.companyFormData.task_ids),
        });
        this.$message.success("保存成功");
        window.sessionStorage.removeItem(BINDING_EDIT_STORAGE_KEY);
        this.$router.push({ path: "/privateTask" });
      } finally {
        this.qrLoading = false;
      }
    },
    async handlePrimaryAction() {
      if (this.isBindingEditMode) {
        await this.saveTaskBinding();
        return;
      }
      await this.checkCategory();
    },
    async checkCategory() {
      const valid = await this.validateForm();
      if (!valid) return;
      this.qrLoading = true;
      try {
        await this.getQRCode();
      } finally {
        this.qrLoading = false;
      }
    },
    async loadBaseData() {
      this.updateWorkModeConfig();
      await Promise.all([
        this.loadCategoryList(),
        this.getDailyTaskIndustryList(),
        this.getQuickRecruitPostList(),
      ]);
    },
  },
  mounted() {
    this.loadBaseData().then(() => {
      if (this.isBindingEditMode) {
        this.initBindingEditData();
      }
    });
  },
};
</script>

<style lang="scss" scoped>
.form-content {
  display: flex;
  flex-flow: column nowrap;
  /deep/ .el-select,
  /deep/ .el-input,
  /deep/ .el-cascader {
    width: 260px;
  }

  /deep/ .el-input.salary-input {
    width: 100%;
  }

  .btn {
    display: flex;
    justify-content: center;
    margin-top: 20px;
  }
}

.quick-create-btn {
  margin-bottom: 10px;
  display: flex;
  justify-content: flex-start;
}

.description-box {
  margin-bottom: 10px;
}

.multiple-picker-wrap {
  display: flex;
  align-items: center;
}

.multiple-picker-wrap--with-action {
  gap: 8px;
}

.picker-field-wrap {
  display: flex;
  align-items: center;
}

.picker-field-wrap--with-tip {
  gap: 8px;
}

.recruit-create-btn {
  flex-shrink: 0;
}

.task-description-label {
  margin-bottom: 6px;

  &:before {
    content: "*";
    color: #f56c6c;
    margin-right: 4px;
  }
}

.task-type-checkbox {
  width: 180px;
  margin: 0 10px;
  margin-bottom: 8px;
  box-sizing: border-box;
}

.text-center {
  text-align: center;
}

.el-icon-warning {
  margin: 5px 0 0 4px;
  color: #409eff;
  font-size: 18px;
}

.dialog-title {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;
  margin-top: -20px;

  .el-icon-success {
    font-size: 40px;
    color: #409eff;
  }
}

.title-text {
  font-size: 20px;
  margin-left: 10px;
}

.center-box {
  display: flex;
  justify-content: center;
  padding: 30px 0;
}

.code {
  text-align: center;
  display: flex;
  flex-flow: column nowrap;
  justify-content: space-between;
  align-items: center;
  height: 200px;
  overflow: hidden;

  &.alipay-code {
    margin-left: 30px;
    position: relative;

    .QR-code {
      position: relative;
      top: -30px;
      width: 220px;
      height: 220px;
    }

    .tips {
      position: absolute;
      bottom: 0;
    }
  }

  .tips {
    margin-top: 10px;
    font-size: 14px;
    color: #333;
  }
}

.QR-code {
  width: 150px;
  height: 150px;
}

.review-notice {
  display: flex;
  align-items: flex-start;
  padding: 10px 0 4px;
  line-height: 24px;
  color: #606266;
}

.review-notice__icon {
  flex-shrink: 0;
  margin: 2px 10px 0 0;
  font-size: 20px;
  color: #e6a23c;
}

.review-notice__content {
  font-size: 14px;
}
</style>
